export default __webpack_public_path__ + "static/media/tnhih.8c1d1664.jpeg";